import { render, staticRenderFns } from "./DialogInfosTask.vue?vue&type=template&id=6ed0f4e6"
import script from "./DialogInfosTask.vue?vue&type=script&lang=js"
export * from "./DialogInfosTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports